module.exports = __webpack_public_path__ + "img/publicis.a0123618.png";